<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1">
        <div class="header-color" style="display: flex; flex-direction: row;">
            <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
                <span translate>Attendance History</span>
            </div>
            <div style="display: flex; flex: 1; flex-direction: row;">
                <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; padding-right: 5px; justify-content: center">
                    <button mat-stroked-button class="mat-card-button" (click)="goToAttendance()"><span translate>Go To Attendance</span>
                    </button>
                </div>
            </div>
        </div>
        <div style="display: flex; flex-direction: column; flex: 1; flex-wrap: wrap; justify-content: center">
            <div *ngIf="recordsToDisplay.length > 0" style="flex: 1;display: flex;justify-content: flex-end;padding: 10px;">
                <tyl-checkbox [(checked)]='showDropped' (change)="hideShowDropped();">Include dropped classes</tyl-checkbox>
            </div>
            <div *ngIf="recordsToDisplay.length == 0" style="flex: 1;display: flex;justify-content: center;padding: 10px;">
                No attendance history available.
            </div>
            <div *ngIf="recordsToDisplay.length > 0" style="display: flex; flex: 1; justify-content: flex-end;padding-right: 7.2%; color: rgba(0, 0, 0, 0.54);font-weight: 500;">
                Year-to-Date
            </div>
            <mat-table *ngIf="recordsToDisplay.length > 0" style="width: 100%;" [dataSource]="recordsToDisplay">
                <!-- Meets Column -->
                <ng-container matColumnDef="meets">
                    <mat-header-cell style="flex: 1; justify-content: center; margin-right: 9px" *matHeaderCellDef>Meets</mat-header-cell>
                    <mat-cell style="flex: 1; justify-content: center; margin-right: 9px" *matCellDef="let ar">
                        <div [innerHTML]="ar.ClassMeets"></div>
                    </mat-cell>
                </ng-container>

                <!-- Term Column -->
                <ng-container matColumnDef="Term">
                    <mat-header-cell style="flex: 1; justify-content: center; margin-right: 9px" *matHeaderCellDef>Term</mat-header-cell>
                    <mat-cell style="flex: 1; justify-content: center; margin-right: 9px" *matCellDef="let ar">{{ar.Term}}</mat-cell>
                </ng-container>

                <!-- Course Section Column -->
                <ng-container matColumnDef="courseSection">
                    <mat-header-cell style="flex: 3" *matHeaderCellDef>Course-Section</mat-header-cell>
                    <mat-cell style="flex: 3" *matCellDef="let ar">{{ar.CourseNumber}}-{{ar.SectionName}}</mat-cell>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <mat-header-cell style="flex: 5" *matHeaderCellDef>Name</mat-header-cell>
                    <mat-cell style="flex: 5" *matCellDef="let ar">{{ar.CourseName}}</mat-cell>
                </ng-container>

                <!-- Dropped Column -->
                <ng-container matColumnDef="dropped">
                    <mat-header-cell [ngClass]="{'show-dropped' : showDropped, 'hide-dropped': !showDropped}" *matHeaderCellDef>
                        <span *ngIf="showDropped">Dropped</span>
                    </mat-header-cell>
                    <mat-cell [ngClass]="{'show-dropped' : showDropped, 'hide-dropped': !showDropped}" *matCellDef="let ar">
                        <span *ngIf="showDropped">{{ar.DroppedDate | date:'MM/dd/yy'}}</span>
                    </mat-cell>
                </ng-container>

                <!-- Present Column -->
                <ng-container matColumnDef="pr">
                    <mat-header-cell style="flex: .6; justify-content: center" *matHeaderCellDef>Pr</mat-header-cell>
                    <mat-cell style="flex: .6; justify-content: center" *matCellDef="let ar" [ngClass]="{'no-data': ar.Present_YTD < 1, 'number-link': ar.Present_YTD > 0}" (click)="ar.Present_YTD > 0 ? attendanceRecordClick(ar.Section_ID, 'Present') : ''">{{ar.Present_YTD}}</mat-cell>
                </ng-container>

                <!-- Tardy Column -->
                <ng-container matColumnDef="td">
                    <mat-header-cell style="flex: .6; justify-content: center" *matHeaderCellDef>Td</mat-header-cell>
                    <mat-cell style="flex: .6; justify-content: center" *matCellDef="let ar" [ngClass]="{'no-data': ar.Tardy_YTD < 1, 'number-link': ar.Tardy_YTD > 0}" (click)="ar.Tardy_YTD > 0 ? attendanceRecordClick(ar.Section_ID, 'Tardy') : ''">{{ar.Tardy_YTD}}</mat-cell>
                </ng-container>

                <!-- Absent Column -->
                <ng-container matColumnDef="ab">
                    <mat-header-cell style="flex: .6; justify-content: center" *matHeaderCellDef>Ab</mat-header-cell>
                    <mat-cell style="flex: .6; justify-content: center" *matCellDef="let ar" [ngClass]="{'no-data': ar.Absent_YTD < 1, 'number-link': ar.Absent_YTD > 0}" (click)="ar.Absent_YTD > 0 ? attendanceRecordClick(ar.Section_ID, 'Absent'): ''">{{ar.Absent_YTD}}</mat-cell>
                </ng-container>

                <!-- Excused Column -->
                <ng-container matColumnDef="ex">
                    <mat-header-cell style="flex: .6; justify-content: center;border-left-style: solid;border-left-width: 1px;border-left-color: lightgray;" *matHeaderCellDef>Ex</mat-header-cell>
                    <mat-cell style="flex: .6; justify-content: center;border-left-style: solid;border-left-width: 1px;border-left-color: lightgray;" *matCellDef="let ar" [ngClass]="{'no-data': ar.ExcusedAbsent_YTD < 1, 'number-link': ar.ExcusedAbsent_YTD > 0}"(click)="ar.ExcusedAbsent_YTD > 0 ? attendanceRecordClick(ar.Section_ID, 'Excused') : ''">{{ar.ExcusedAbsent_YTD}}</mat-cell>
                </ng-container>

                <!-- Unexcused Column -->
                <ng-container matColumnDef="un">
                    <mat-header-cell style="flex: .6; justify-content: center" *matHeaderCellDef>Un</mat-header-cell>
                    <mat-cell style="flex: .6; justify-content: center" *matCellDef="let ar" [ngClass]="{'no-data': ar.UnexcusedAbsent_YTD < 1, 'number-link': ar.UnexcusedAbsent_YTD > 0}" (click)="ar.UnexcusedAbsent_YTD > 0 ? attendanceRecordClick(ar.Section_ID, 'Unexcused') : ''">{{ar.UnexcusedAbsent_YTD}}</mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row [ngClass]="{'dropped-course': row.IsDropped}" style="align-items: flex-start;" *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
        </div>
    </div>
</mat-card>
